import { Components, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function popover(theme: Theme): Components {
  return {
    MuiPopover: {
      styleOverrides: {
        paper: {
          borderRadius: '4px !important',
          boxShadow: '0 1px 8px rgba(0, 0, 0, 0.12)',
          backgroundColor: theme.palette.background.paper,
        },
      },
    },
  };
}
